export default __webpack_public_path__ + "static/media/9.ad8fe800.jpg";